export const UPDATE_DOWNTIME_STATE = 'UPDATE_DOWNTIME_STATE';
export const DOWNTIME_LOADING = 'DOWNTIME_LOADING';
export const DOWNTIME_LOADED = 'DOWNTIME_LOADED';
export const DOWNTIME_LOAD_ERROR = 'DOWNTIME_LOAD_ERROR';
export const DOWNTIME_CREATED = 'DOWNTIME_CREATED';
export const DOWNTIME_UPDATED = 'DOWNTIME_UPDATED';


// WEBPACK FOOTER //
// ./src/data/redux/downtime_details/actiontypes.js